import { render, staticRenderFns } from "./risk-applied-control-recommendation.vue?vue&type=template&id=709cb5a8&"
import script from "./risk-applied-control-recommendation.vue?vue&type=script&lang=js&"
export * from "./risk-applied-control-recommendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports